import React, { ReactElement, useEffect, useState } from 'react';
import { AxiosResponse } from 'axios';

import { ModulesHeader, ModulesDescription, useModules, ModulesDetailsApiResponse } from 'features/modules';
import { ContentsList } from 'features/contents';
import { useSchool } from 'features/school';
import { createUrl, request } from 'app/utils';
import { Loading, Page } from 'components';
import { useParams } from 'react-router-dom';
import { ProductDetailsApiResponse, useProducts } from 'features/products';
import { useMenu } from 'features/menu';
import { AgreementsMessage } from 'features/agreements';

const ModulesDetailsView = (): ReactElement => {
  const [loading, setLoading] = useState(true);

  const { apiGatewayUrl, schoolUuid } = useSchool();
  const { moduleDetails, setModuleDetails, clearModuleDetails } = useModules();
  const { setProductDetails, clearProductDetails } = useProducts();
  const { setBackPathname, backPathname } = useMenu();

  const { productSlug, productClassUuid, moduleUuid } = useParams();

  const fetch = async () => {
    await Promise.all([
      request({
        url: `/api/v1/School/Products/${productSlug}${productClassUuid ? `?productClassUuid=${productClassUuid}` : ``}`,
        method: 'get',
        baseURL: apiGatewayUrl,
      }).then((response: AxiosResponse<ProductDetailsApiResponse>) => {
        setProductDetails(response.data);
      }),
      request({
        url: `/api/v1/School/ProductContentTimeline/${productSlug}/${moduleUuid}${productClassUuid ? `?productClassUuid=${productClassUuid}` : ``}`,
        method: 'get',
        baseURL: apiGatewayUrl,
      }).then((response: AxiosResponse<ModulesDetailsApiResponse>) => {
        setModuleDetails(response.data);
      }),
    ]).then(() => {
      setLoading(false);

      if (!backPathname) {
        setBackPathname(
          productClassUuid ? createUrl('productClassDetails', [productSlug, productClassUuid]) : createUrl('productDetails', [productSlug])
        );
      }
    });
  };

  useEffect(() => {
    fetch();

    return () => {
      clearProductDetails();
      clearModuleDetails();
    };
  }, []);

  let showDescription = true;

  if (
    schoolUuid === '76cebc79-bf6c-4144-bab2-947362f3f8c4' &&
    (productSlug === 'PRODUTO-APOSTILA-TERMINE-SEUS-ESTUDOS' || productSlug === 'PRODUTO-GRUPO-EU-VOU')
  ) {
    showDescription = false;
  }

  if (loading || !moduleDetails) return <Loading label="Por favor, aguarde." />;

  return (
    <Page title={moduleDetails.name}>
      <AgreementsMessage productSlug={productSlug} />

      <ModulesHeader />

      {showDescription && <ModulesDescription />}

      <ContentsList />
    </Page>
  );
};
export default ModulesDetailsView;
